import { COL_SIZING } from "./constants";

/**
 * TMTableHeader Component
 * Displays the header row for the Time & Materials line items table
 * @param {boolean} showPricing - Show pricing columns (Price/Unit RT, Price/Unit OT, Total)
 * @param {boolean} readOnly - Hides the Actions column when true
 */
const TMTableHeader = ({ showPricing = false, readOnly = false }) => {
  const getColClass = (col) => {
    return showPricing ? COL_SIZING.pricing[col] : COL_SIZING.report[col];
  };

  return (
    <thead className="bg-gray-100">
      <tr>
        <th
          className={`${getColClass("option")} pl-2 pr-1 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider`}
        >
          Option
        </th>
        <th
          className={`${getColClass("quantity")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
        >
          Qty
        </th>
        <th
          className={`${getColClass("rtHours")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
        >
          RT
        </th>
        <th
          className={`${getColClass("otHours")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
        >
          OT
        </th>
        <th
          className={`${getColClass("unit")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
        >
          Unit
        </th>
        {showPricing && (
          <>
            <th
              className={`${getColClass("pricePerUnitRT")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
            >
              <span className="md:hidden">P/U</span>
              <span className="hidden md:inline">Price/Unit</span>
            </th>
            <th
              className={`${getColClass("pricePerUnitOT")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
            >
              <span className="md:hidden">P/U (OT)</span>
              <span className="hidden md:inline">Price/Unit (OT)</span>
            </th>
            <th
              className={`${getColClass("total")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
            >
              Total
            </th>
          </>
        )}
        {!readOnly && (
          <th
            className={`${getColClass("actions")} px-[2px] md:px-2 py-3 text-center md:text-right text-xs font-medium text-gray-700 uppercase tracking-wider`}
          >
            Actions
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TMTableHeader;
